/* globals MEDIA_ROOT, WEB_ROOT */

import { stringifyQS } from '../../../utils';

/**
 * Single source of data for all content pages
 *
 * TODO: Retrieve this from a CMS when it becomes regularly updated.
 */
const data = {
  all: {
    slug: 'all',
    label: 'Events',
    title: 'Events',
    meta: {
      description:
        'Find upcoming local running, triathlon, obstacle events near you with Let’s Do This. We make it simple to search for local 5ks, 10ks, marathons, ultramarathons, sprint, ironman and olympic triathlon.',
    },
    image: {
      large: 'https://d178fu9mi2dmkb.cloudfront.net/uploads/2017/07/07143853/running-1024x683.jpg',
      small: `${MEDIA_ROOT}/images/discover/running-400x267_3_tinted.jpg`,
    },
    query: {},
  },

  running: {
    slug: 'running',
    label: 'Running',
    title: 'Running Events',
    meta: {},
    description:
      '<p>Running is the world’s most accessible sport. Park runs, colour runs, 5k, 10k, half marathons, marathons and ultras — all you need is a pair of trainers and off you go. Running events are hugely popular on Let’s Do This and it’s a sociable sport, so get some friends involved and achieve something extraordinary.</p><p>If you’re starting small, the 5k and 10k events are great fun and definitely worth doing even if you’re training for a bigger challenge further down the line. Getting used to the atmosphere of an event is important. You’re so much more likely to hit a better time if there’s a crowd cheering you on, people in fancy dress and a big celebration at the finish line.</p><h2>Find local Running races</h2><p>Today, with international organisations, local clubs and national events to choose from, there are thousands of races to discover, and we want to help you find them quickly and easily. Below you’ll find selections by running type, running location and some exceptional events to take part in.</p>',
    image: {
      large: 'https://d178fu9mi2dmkb.cloudfront.net/uploads/2017/07/07143853/running-1024x683.jpg',
      small: `${MEDIA_ROOT}/images/discover/running-400x267_3_tinted.jpg`,
    },
    query: {
      sport: 3,
    },

    filters: {
      'beginner-friendly': {
        slug: 'beginner-friendly',
        label: 'Beginner Friendly',
        title: 'Beginner Friendly Running Events',
        meta: {
          description:
            'Whether you’re completely new to running or just getting back into the swing of things, we’ve got some great race recommendations to get you started.',
        },
        description:
          '<p>Whether you’re completely new to running or just getting back into the swing of things, we’ve got some great race recommendations to get you started. Chosen by our team, these are some of our favourite events for first-timers. <a href="/running-events/5k">5k races</a> & <a href="/running-events/10k">10k races</a> are perfect for beginners, they tend to be relatively flat (always check the elevation just in case) and there’ll usually be a great crowd to cheer you on.</p><h2>Find the right running event for you</h2><p>To keep motivated try to run with friends and to organise a race a few months away as something to work towards. Running as a sport is very inclusive, people love to chat and give a boost to those around them! Practice makes perfect so with the right training you can achieve anything. Start small and it won’t be long before you’re a total professional tackling the bigger races.</p>',
        image: {
          large:
            'https://d178fu9mi2dmkb.cloudfront.net/uploads/2017/09/26111725/discover-5k-1024x819.jpg',
          small: `${MEDIA_ROOT}/images/discover/5k-400x267_3_tinted.jpg`,
        },
        query: {
          sport: 3,
          sportDistance: 166,
        },
      },

      'half-marathon': {
        slug: 'half-marathon',
        label: 'Half Marathon',
        title: 'Half Marathon Events',
        meta: {},
        description:
          '<p>At 13.1 miles, a half marathon is long enough to test even the strongest runners, but short enough for almost anyone determined to conquer their next challenge. We have a jam-packed calendar of half marathons taking place up and down the country — from big ballot events to local community races and spectacular trail runs. Get involved and conquer your next challenge.</p><h2>Find local Half Marathon running races</h2><p>A half marathon is a fantastic event for those new to running to really push themselves, or as a great warm up event for those ready to tackle a full marathon or even an <a href="/running-events/ultramarathon">ultramarathon</a></p><dl><dt>What is the distance covered in half marathon?</dt><dd>The half marathon is one of running`s most popular distance - a half marathon is 13.1 miles (or 21.1km). </dd><dt>What is an average time for a half marathon?</dt><dd>Breaking 2:00 (9:09 per mile pace) is a common goal, and that time is considered a respectable half marathon time among runners. The average times for half marathons in the U.S. in 2015 were 2:04:00 for males and 2:22:21 for females. <dt>What is the half marathon world record?</dt><dd>The world record for men is 58:23 for men and 1:04:52 for women.<dt>How long does it take to train for a half marathon?</dt><dd>If you are working with a training plan you can achieve a half marathon in 8 weeks.</dd>',
        image: {
          large:
            'https://d178fu9mi2dmkb.cloudfront.net/uploads/2017/09/26111839/discover-half-marathons-1024x683.jpg',
          small: `${MEDIA_ROOT}/images/discover/half-marathons-400x267_3_tinted.jpg`,
        },
        query: {
          sport: 3,
          sportDistance: 170,
        },
      },

      '10k': {
        slug: '10k',
        label: '10k',
        title: '10k Running Events',
        meta: {
          description:
            'Let’s Do This helps you find the best local 10k running events. Challenge yourself today and find your next 10k run with Let’s Do This.',
        },
        description:
          '<p>10k runs are very popular, they’re an achievable challenge for anyone with enough training and are therefore some of the most fun and most inclusive events. 10ks are perfect team events, train with friends and colleagues and get a group together for race day.</p><h2>Find local 10k running races</h2><p>10ks are so popular you won’t have trouble finding one near you, whether it’s fancy dress for the BHF, or completing the Royal Parks Series (one in every major London park). 10ks are an excellent way to kick off the season if you’re a marathon runner or triathlete, they’re also a fun way to meet new people and get involved for charity.</p><p>Ready for an even bigger challenge? Take a look at our <a href="/running-events/half-marathon">half marathon</a> and <a href="/running-events/marathon">full marathon</a> events too</p>',
        image: {
          large:
            'https://d178fu9mi2dmkb.cloudfront.net/uploads/2017/09/26111754/discover-10k-1024x683.jpg',
          small: 'https://d178fu9mi2dmkb.cloudfront.net/uploads/2018/03/16050713/10k-400x267.jpg',
        },
        query: {
          sport: 3,
          sportDistance: 168,
        },
      },

      marathon: {
        slug: 'marathon',
        label: 'Marathon',
        title: 'Marathon Events',
        meta: {},
        description:
          '<p>The marathon is the benchmark for any runner. Its history stretches back to the Ancient Greeks, and it now includes all the world’s most iconic running races. At 26.2 miles, it’s a massive test of physical and mental resilience. If it’s a PB you’re after, you can choose a fast, flat city course, or else go for a more challenging trail run in one of the world’s most stunning locations.</p> <p>Think a marathon might be pushing it? Why not ease yourself in with a <a href="/running-events/5k">5k</a> or <a href="/running-events/10k">10k</a> run instead?</p><h2>Find local Marathon running races</h2><p>Wherever you are based, you are sure to find a fantastic marathon event that’s local to you. If you are looking for marathon events close by, simply use our search to see which marathon’s near you are taking place this year and beyond.</p>',
        image: {
          large:
            'https://d178fu9mi2dmkb.cloudfront.net/uploads/2017/09/26111905/discover-marathons-1024x683.jpg',
          small: `${MEDIA_ROOT}/images/discover/marathons-400x267_3_tinted.jpg`,
        },
        query: {
          sport: 3,
          sportDistance: 169,
        },
      },

      '5k': {
        slug: '5k',
        label: '5k',
        title: '5k Running Events',
        meta: {
          description:
            '5km is the perfect entry-level running distance. Find 5k races and fun-runs with Let’s Do This.',
        },
        description:
          '<p>A 5k run is the perfect distance for a beginner, it’s 3.1 miles and is the shortest and most popular road running distance. It’s a great goal to include in your fitness regime because there’s no pressure, people walk, jog or sprint so it’s totally up to you.</p><h2>Find local 5k running races</h2><p> There are loads of great 5k events, they tend to attract a great crowd and are very family orientated. From runs around the London Parks, to night runs and family events, you won’t be short of 5ks to choose from. Most marathon events such as London or Berlin have a 10k and a 5k race as well so it’s worth checking the larger events.</p>',
        image: {
          large:
            'https://d178fu9mi2dmkb.cloudfront.net/uploads/2017/09/26111725/discover-5k-1024x819.jpg',
          small: `${MEDIA_ROOT}/images/discover/5k-400x267_3_tinted.jpg`,
        },
        query: {
          sport: 3,
          sportDistance: 166,
        },
      },

      ultramarathon: {
        slug: 'ultramarathon',
        label: 'Ultramarathon',
        title: 'Ultramarathon Events',
        meta: {
          description:
            'Find extreme endurance running races with the Let’s Do This ultramarathon schedule. Find ultramarathons near you today by searching with Let’s Do This.',
        },
        description:
          '<p>An ultramarathon is any running race longer than a traditional marathon of 26.2 miles. Most of them take place on trails, often surrounded by spectacular scenery, and involve continuously stuffing your face to keep your body going mile after mile. At the extreme end, ultras can involve running more than 300km over multiple days through mountains, deserts, jungles and snow. But if this is your first ultra, you might want to start with something a little shorter, like a “gentle” 50km.</p>',
        image: {
          large:
            'https://d178fu9mi2dmkb.cloudfront.net/uploads/2017/09/26112029/discover-ultramarathons-1024x683.jpg',
          small: `${MEDIA_ROOT}/images/discover/ultramarathons-400x267_3_tinted.jpg`,
        },
        query: {
          sport: 3,
          sportDistance: 171,
        },
      },
    },
  },

  triathlon: {
    slug: 'triathlon',
    label: 'Triathlon',
    title: 'Triathlon Events',
    meta: {
      description:
        'Find upcoming local triathlon events near you with Let’s Do This. We make it simple to search for local Super Sprint, Sprint, Olympic, Half Ironman and Ironman distance triathlons.',
    },
    description:
      '<p>We handpick the very best triathlon events, so you don’t have to waste any of that precious energy looking. We have pulled together a fantastic variety of triathlon events — from exotic locations such as the sandy beaches of Indonesia, breath taking scenery in the mountain peaks of Norway, or simply along the rolling hills of the English countryside.</p><h2>Find local triathlon events near you</h2><p>If you are looking for local triathlon events look no further. Whether you are looking for a <a href="/triathlon-events/super-sprint">Super Sprint triathlon</a> to ease you in, an impressive <a href="/triathlon-events/olympic">Olympic distance</a> for a massive challenge, or want to really push yourself with a <a href="/triathlon-events/half-ironman">Half Ironman</a> or full <a href="/triathlon-events/ironman">Ironman</a>, here you can find details of a huge range of local triathlon events in both the UK and all over the world.</p>',
    image: {
      large:
        'https://d178fu9mi2dmkb.cloudfront.net/uploads/2018/01/25044838/1440x447px_triathlon.png',
      small: `${MEDIA_ROOT}/images/discover/triathlon-400x267_3_tinted.jpg`,
    },
    query: {
      sport: 6,
    },

    filters: {
      'beginner-friendly': {
        slug: 'beginner-friendly',
        label: 'Beginner Friendly',
        title: 'Beginner Friendly Triathlon Events',
        meta: {
          description:
            'Whether you’re completely new to triathlons or just getting back into the swing of things, we’ve got some great race recommendations to get you started.',
        },
        description:
          '<p>If you’re just starting out, the best thing to do would be to book a Super Sprint or Sprint distance triathlon as these are the shortest two. There are lots of different ranges of abilities in triathlon so there’ll always be people actually ‘sprinting’ the Sprint distance but generally Sprints and Super Sprints are the best to get a feel for the sport. You can see the specific distances here.</p><h2>Different Triathlon event types</h2><ul><li><a href="/triathlon-events/super-sprint">Super sprint triathlon</a>: 400m/10km/2.5km</li><li><a href="/triathlon-events/sprint">Sprint distance triathlon</a>: 750m/20km/5km</li><li><a href="/triathlon-events/olympic">Olympic distance triathlon</a>: 1500m/40km/10km</li><li><a href="/triathlon-events/half-ironman">Half Ironman triathlon</a>: 1.9km/90km/21km</li><li><a href="/triathlon-events/ironman">Ironman distance triathlon</a>: 3.8km/180km/42km</li></ul><p>Triathlons are an all day affair, so get a group together and go to the pub for lunch afterwards. Our experience is that most events happen in cool areas such as Dorney Lake in Windsor, so it’s a great excuse to escape the city for the day. They draw good crowds, and you’ll always have people cheering you on. Super Sprints tend to be very quick, so depending on your fitness level, you might want to choose a Sprint distance so you have enough time to enjoy each stage of the race. On average, Sprint triathlons will be over and done within 1.45–2 hours so it’ll go by in a flash.</p><h2>Find the right triathlon for you</h2><p>It’s important to have the right kit, you need a wetsuit that allows you to move and a good bike. We’ve collected a few of our favourite tris for beginners below, they’re great fun and certainly won’t disappoint. Best of luck from all of us here at LDT.</p>',
        image: {
          large:
            'https://d178fu9mi2dmkb.cloudfront.net/uploads/2017/09/26112022/discover-super-sprint-triathlons-1024x743.jpg',
          small: `${MEDIA_ROOT}/images/discover/super-sprint-triathlons-400x267_3_tinted.jpg`,
        },
        query: {
          sport: 6,
          sportDistance: 172,
        },
      },

      'super-sprint': {
        slug: 'super-sprint',
        label: 'Super Sprint',
        title: 'Super Sprint Triathlon Events',
        meta: {
          description:
            'Search local Super Sprint triathlons with Let’s Do This. Push your limits with nearby Super Sprint triathlons.',
        },
        description:
          '<p>Super Sprint is the shortest triathlon distance. 400m swim, 10km bike, and 2.5km. Quite often they take place in swimming pools making them even more accessible</p>',
        image: {
          large:
            'https://d178fu9mi2dmkb.cloudfront.net/uploads/2017/09/26112022/discover-super-sprint-triathlons-1024x743.jpg',
          small: `${MEDIA_ROOT}/images/discover/super-sprint-triathlons-400x267_3_tinted.jpg`,
        },
        query: {
          sport: 6,
          sportDistance: 174,
        },
      },

      sprint: {
        slug: 'sprint',
        label: 'Sprint',
        title: 'Sprint Triathlon Events',
        meta: {
          description:
            'A great entry-level triathlon distance. Sprint distance triathlons consist of 400m swim, 10km bike, 5km run.',
        },
        description:
          '<p>A great entry-level triathlon distance. Sprint distance triathlons consist of 400m swim, 10km bike, 5km run.</p>',
        image: {
          large:
            'https://d178fu9mi2dmkb.cloudfront.net/uploads/2017/09/26112010/discover-sprint-triathlons-1024x720.jpg',
          small: `${MEDIA_ROOT}/images/discover/sprint-triathlons-400x267_3_tinted.jpg`,
        },
        query: {
          sport: 6,
          sportDistance: 172,
        },
      },

      olympic: {
        slug: 'olympic',
        label: 'Olympic',
        title: 'Olympic Triathlon Events',
        meta: {
          description:
            'Bringing you the best standard distance triathlon events — swim 750m, bike 40km, run 10km.',
        },
        description:
          '<p>Bringing you the best standard distance triathlon events — swim 750m, bike 40km, run 10km.</p>',
        image: {
          large:
            'https://d178fu9mi2dmkb.cloudfront.net/uploads/2017/09/26111926/discover-olympic-triathlons-1024x627.jpg',
          small: `${MEDIA_ROOT}/images/discover/olympic-triathlons-400x267_3_tinted.jpg`,
        },
        query: {
          sport: 6,
          sportDistance: 130,
        },
      },

      'half-ironman': {
        slug: 'half-ironman',
        label: 'Half Ironman',
        title: 'Half Ironman Triathlon Events',
        meta: {
          description:
            'Discover awesome Half Ironman — also known as middle distance, or 70.3 — triathlon events. Swim 1.9km, bike 90km, run 20km.',
        },
        description:
          '<p>Discover awesome Half Ironman — also known as middle distance, or 70.3 — triathlon events. Swim 1.9km, bike 90km, run 20km.</p>',
        image: {
          large:
            'https://d178fu9mi2dmkb.cloudfront.net/uploads/2017/09/26111828/discover-half-ironmans-1024x683.jpg',
          small: `${MEDIA_ROOT}/images/discover/half-ironmans-400x267_3_tinted.jpg`,
        },
        query: {
          sport: 6,
          sportDistance: 183,
        },
      },

      ironman: {
        slug: 'ironman',
        label: 'Ironman',
        title: 'Ironman Triathlon Events',
        meta: {
          description:
            'An Ironman 140.6 is the ultimate in long distance triathlon events. Swim 3.8km, bike 180km, run 40km.',
        },
        description:
          '<p>An Ironman 140.6 is the ultimate in long distance triathlon events. Swim 3.8km, bike 180km, run 40km.</p>',
        image: {
          large:
            'https://d178fu9mi2dmkb.cloudfront.net/uploads/2017/09/26111848/discover-ironman-triathlons-1024x678.jpg',
          small: `${MEDIA_ROOT}/images/discover/ironman-triathlons-400x267_3_tinted.jpg`,
        },
        query: {
          sport: 6,
          sportDistance: 184,
        },
      },
    },
  },

  duathlon: {
    slug: 'duathlon',
    label: 'Duathlon',
    title: 'Duathlon Events',
    meta: {},
    description:
      '<p>Duathlons were primarily created to allow triathletes to race during the winter months without the need to swim in cold lakes. It’s a running and cycling event that has become very popular in recent years, they’re great training races for triathlon and make an excellent step up from single running/cycling events. So, if you want to broaden your horizons and move into multi-disciplinary events, Duathlon is an excellent place to start.</p><p>Duathlons tend to follow the same distance structure as triathlons, although the format is typically ‘Run—Bike—Run’ meaning you start with a run, then transition to the bike, then transition back to running again. Duathlons come in Sprint, Standard and Long distances.</p><h2>Different Duathlon event types</h2><ul><li>Sprint Duathlon: 5km run, 20km bike, 2.5km run</li><li>Standard Distance Duathlon: 10km run, 40km bike, 5km run</li><li>Long Distance Duathlon: 10km run, 150km bike, 30km run</li></ul><p>These distances aren’t as standardised as <a href="/triathlon-events">Triathlons</a>, so do check the exact course. Duathlon races can cover all terrains with opportunities to run cross country and mountain bike. We’ve curated some of our favourites below, good luck out there!</p>',
    image: {
      large: 'https://d178fu9mi2dmkb.cloudfront.net/uploads/2017/07/07143811/duathlon-1024x680.jpg',
      small: `${MEDIA_ROOT}/images/discover/duathlon-400x267_3_tinted.jpg`,
    },
    query: {
      sport: 18,
    },
  },

  'mountain-biking': {
    slug: 'mountain-biking',
    label: 'Mountain Biking',
    title: 'Mountain Biking Events',
    meta: {},
    description:
      '<p>Mountain biking is riding bicycles off-road (as opposed to <a href="/road-cycling-events">Road Cycling</a> events) and often over rough terrain, using specially designed bikes with features designed to enhance durability and performance. Mountain biking can generally be broken down into multiple categories: cross country, trail riding, all mountain (also referred to as “Enduro”), downhill, freeride and dirt jumping. However, the majority of mountain biking falls into the categories of Trail and Cross Country riding styles.</p><h2>Find the right Mountain biking event for you</h2><p>Mountain bikers ride off-road trails such as singletrack, back-country roads, fire roads, and often venture to ski resorts that stay open in the summer for such activities. Because riders are often far from civilisation, there’s a strong ethic of self-reliance in the sport. Riders learn to repair broken bikes and flat tires to avoid getting stranded. Many riders carry a backpack, including water, food, tools for trailside repairs and a first aid kit in case of injury. Group rides are common, especially on longer treks. Map navigation skills will come in handy.</p><p>Here at Let’s Do This we want to help you find exactly the right event. By working with some of the most renowned Mountain Bike Race organisations in the space, we’ve got a great selection of epic challenges below.</p>',
    image: {
      large: 'https://d178fu9mi2dmkb.cloudfront.net/uploads/2017/07/07143731/mtb-1024x564.jpg',
      small: `${MEDIA_ROOT}/images/discover/mtb-400x267_3_tinted.jpg`,
    },
    query: {
      sport: 49,
    },
  },

  'road-cycling': {
    slug: 'road-cycling',
    label: 'Road Cycling',
    title: 'Road Cycling Events',
    meta: {},
    description:
      '<p>Discover UK and International Road Cycling events. Featuring Sportives, Gran Fondos and Charity Bike Rides in our 2018 Cycling Calendar. Cycling is a hugely popular sport but can sometimes seem a closely guarded secret, there’s a lot of jargon and kit but once you pop, you absolutely can’t stop. It’s a great weekend activity, go with friends and cruise round city parks or country lanes, you’ll be addicted in no time.</p><h2>Different road cycling event types</h2><p>We sort our cycling events by Short (0-50km), Medium (50-100km), Long (100-200km) and Ultra (200km+). Most of these are Sportives. Here are some cycling event names defined:<ul><li>Gran Fondo — a mass participation cycling event at least 120km long. A large event with closed roads, usually chip timed. People travel all over Europe to compete in these events.</li><li>Century — a cycle of 100 miles (160.9 km) or more within 12 hours, usually as a club sponsored event. A large event with closed roads, people can get there PBs here. Usually chip timed.</li><li>Sportives — most of the cycling events on our site are sportives, these are the most popular endurance cycling events. They’re held all over the world and rarely exclude traffic. They’re more relaxed and whilst people do go for PBs it’s a much more convivial atmosphere than the more formal Gran Fondo races.</li></ul></p>',
    image: {
      large:
        'https://d178fu9mi2dmkb.cloudfront.net/uploads/2017/07/07143941/road-cycling-670x270.jpg',
      small: `${MEDIA_ROOT}/images/discover/road-cycling-400x267_3_tinted.jpg`,
    },
    query: {
      sport: 39,
    },
  },

  'obstacle-course': {
    slug: 'obstacle-course',
    label: 'Obstacle Races',
    title: 'Obstacle Races',
    meta: {},
    description:
      '<p>Obstacle Course Racing (OCR) involves a competitor travelling on foot overcoming various physical challenges or obstacles. The most common form of these are a combination of mud and trail runs, and the big players in the space are Tough Mudder, Spartan Race & Born Survivor.</p><h2>Different obstacle event types</h2><p>The obstacles used are often similar to those used in military training and tend to include climbing over walls, carrying heavy objects, traversing bodies of water, crawling under barbed wire and jumping through fire. They’re epic when done with friends, and these events are big on the social side so get a team together, get the war paint on and get ready for big celebrations and post-race beers.</p><h2>Find the right obstacle race for you</h2><p>These obstacle races are happening all over the world, with varying style and difficulty, so it’s time to jump on that bandwagon! Here are some of our most popular events, if you haven’t done one before, you absolutely must.</p>',
    image: {
      large: 'https://d178fu9mi2dmkb.cloudfront.net/uploads/2017/07/07143818/obstacle-1024x678.jpg',
      small: `${MEDIA_ROOT}/images/discover/obstacle-400x267_3_tinted.jpg`,
    },
    query: {
      sport: 13,
    },
  },

  swimming: {
    slug: 'swimming',
    label: 'Swimming',
    title: 'Swimming Events',
    meta: {},
    description:
      '<p>Swimming races and open water swimming events generally tend to be between 1—10km in length, however, more challenging swims can be up to 80km long. Swims over 10km are classed as Marathon Swims, These events take place in lakes or in the sea, often with a great atmosphere and a festival vibe. If you’re just starting out, get some practice in a pool first, temperature and choppiness are factors to consider before diving in.</p><p>From a quick dip in Dorney lake to mastering the Windermere One Way, we’ve collected some of the best open water swimming races below. If you’re feeling adventurous and want to throw in some other disciplines, you can check out our pages on <a href="/swimrun-events">Swimrun</a> & <a href="/triathlon-events">Triathlon</a> too.</p>',
    image: {
      large: 'https://d178fu9mi2dmkb.cloudfront.net/uploads/2017/07/07143827/swimming-1024x768.jpg',
      small: `${MEDIA_ROOT}/images/discover/swimming-400x267_3_tinted.jpg`,
    },
    query: {
      sport: 15,
    },
  },

  swimrun: {
    slug: 'swimrun',
    label: 'Swimrun',
    title: 'Swimrun Events',
    meta: {},
    description:
      '<p>What started out as a drunken bet between two friends in Sweden is fast becoming one of the more popular multi-sport racing events. Swimruns are always carried out outdoors and in open water where your goal is to go from a start to finish through a course with several checkpoints. It has several stages, which means you have to switch between running and swimming several times.</p><p>You enter as a two person team, and usually you have to be within 10m of each other for the whole race. Some people tie themselves together to make sure they don’t drift during the swim. The original ÖTILLÖ in Stockholm is regarded as one of the toughest adventure races around, but as the sport grows there are events suitable for newbies as well as hardened endurance athletes. We’ve created a list of our favourites, from swimruns in Wales, Cumbria, Scotland and the Scilly Isles, you’re sure to find an adventure that suits.</p>',
    image: {
      large: 'https://d178fu9mi2dmkb.cloudfront.net/uploads/2017/07/07143805/swimrun-1024x684.jpg',
      small: `${MEDIA_ROOT}/images/discover/swimrun-400x267_3_tinted.jpg`,
    },
    query: {
      sport: 16,
    },
  },
};

export const locale = [
  { slug: 'au', hreflang: 'en-au', label: 'Australia' },
  { slug: 'gb', hreflang: 'en-gb', label: 'UK' },
  { slug: 'us', hreflang: 'en-us', label: 'United States' },
  { hreflang: 'x-default' },
];

//
const otherSports = [
  { slug: 'running', title: 'Running' },
  { slug: 'road-cycling', title: 'Road cycling' },
  { slug: 'triathlon', title: 'Triathlons' },
  { slug: 'swimming', title: 'Swimming' },
  { slug: 'obstacle-course', title: 'Obstacle races' },
  { slug: 'swimrun', title: 'Swimrun' },
].map(other => ({
  ...other,

  //
  image: data[other.slug].image.small,

  //
  permalink: `/${other.slug}-events`,
}));

//
const normalise = rawData =>
  Object.keys(data).reduce((obj, key) => {
    const sport = rawData[key];
    return {
      ...obj,
      [key]: {
        ...sport,
        locale,
        // Create
        permalink: `/${sport.slug}-events`,
        meta: {
          ...sport.meta,
          title: `Find ${sport.title} near me`,
          hrefLang: locale.map(lang => ({
            rel: 'alternate',
            hreflang: lang.hreflang,
            href: lang.slug
              ? `${WEB_ROOT}/${lang.slug}/${sport.slug}-events`
              : `${WEB_ROOT}/${sport.slug}-events`,
          })),
        },
        //
        searchLink: `/s?${stringifyQS(sport.query)}`,

        //
        ...(sport.filters ? {
          filters: Object.keys(sport.filters).reduce((filters, k) => {
            const filter = sport.filters[k];
            return {
              ...filters,
              [k]: {
                ...filter,

                //
                parent: {
                  label: sport.label,
                  permalink: `/${sport.slug}-events`,
                },

                //
                permalink: `/${sport.slug}-events/${filter.slug}`,

                meta: {
                  ...filter.meta,
                  title: `Find ${filter.title} near me`,
                  hrefLang: filter.locale
                    ? filter.locale.map(lang => ({ rel: 'alternate', hreflang: lang.hreflang, href: `${WEB_ROOT}/${lang.slug ? `${lang.slug}/` : ''}${sport.slug}-events/${filter.slug}` }))
                    : locale.map(lang => ({ rel: 'alternate', hreflang: lang.hreflang, href: `${WEB_ROOT}/${lang.slug ? `${lang.slug}/` : ''}${sport.slug}-events/${filter.slug}` })),
                },
                //
                searchLink: `/s?${stringifyQS(filter.query)}`,
                //
                locale,
                //
                lists: [
                  {
                    title: `Trending ${filter.title}`,
                    query: filter.query,
                    searchLink: `/s?${stringifyQS(filter.query)}`,
                  },
                ],

                otherSports,
              },
            };
          }, {}),
        } : {
          filters: [],
        }),

        //
        lists: [
          {
            title: `Trending ${sport.title}`,
            query: sport.query,
            searchLink: `/s?${stringifyQS(sport.query)}`,
          },
        ],

        otherSports,

      },
    };
  }, {});

export default normalise(data);



// WEBPACK FOOTER //
// ./app/src/components/Discovery/data/index.js